@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.accordionWrapper {
    border-top: 1px solid var(--color-silver);
}

.columns {
    display: flex;
    padding-left: 32px;

    @include breakpoint.breakpoint(layout.$aboveLargeLine) {
        flex: 1;
    }

    @include breakpoint.breakpoint(layout.$belowMedium) {
        display: block;
        padding-left: 0;
    }
}
